import React from 'react';
import { useVirtualizer, type VirtualItem } from '@tanstack/react-virtual';

type VirtualTableData<T> = {
  rows: T[];
  tableContainerRef: React.RefObject<HTMLDivElement>;
};

type TableData = {
  paddingTop: number;
  paddingBottom: number;
  visibleRows: VirtualItem[];
};

export function useTableData<T>(data: VirtualTableData<T>): TableData {
  const rowVirtualizer = useVirtualizer({
    count: data.rows.length,
    getScrollElement: () => data.tableContainerRef.current,
    estimateSize: () => 50,
    overscan: 15,
  });

  const virtualRows = rowVirtualizer.getVirtualItems();
  const totalSize = rowVirtualizer.getTotalSize();
  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
  const paddingBottom =
    virtualRows.length > 0 ? totalSize - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0;

  return {
    paddingTop,
    paddingBottom,
    visibleRows: virtualRows,
  };
}
